import { createContext, useEffect, useState } from 'react';
import { LOADING_DELAY_MS, storesDisplayVKDating } from './consts';
import { DeviceType } from '../../types';

interface AppContextProps {
  isLoading: boolean;
  storesData: (typeof storesDisplayVKDating)['ios'];
  deviceType: DeviceType;
  stage: string;
}

const initialState: AppContextProps = {
  isLoading: true,
  stage: 'disabed',
  storesData: [],
  deviceType: 'desktop',
};

export const AppContext = createContext<AppContextProps>(initialState);

interface AppProviderProps {
  children: React.ReactNode;
  isLangConfigLoading: boolean;
}

const getPlatform = (): keyof typeof storesDisplayVKDating => {
  // TODO use detectDeviceInfo from djs
  const ua = navigator.userAgent;
  if (ua?.match(/iPhone|iPad|iPod/i)) return 'ios';
  if (ua?.match(/Android/i)) return 'android';
  return 'web';
};

export function AppProvider(props: AppProviderProps) {
  const { children, isLangConfigLoading } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [deviceType, setDeviceType] = useState<DeviceType>('desktop');

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    if (!isLangConfigLoading) {
      timer = setTimeout(() => {
        setIsLoading(false);
      }, LOADING_DELAY_MS);
    } else {
      setIsLoading(true);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [isLangConfigLoading]);

  useEffect(() => {
    const updateWindowDimensions = () => {
      const width = window.innerWidth;

      if (width >= 1366) setDeviceType('desktop');
      else if (width >= 800) setDeviceType('tablet');
      else setDeviceType('mobile');
    };

    updateWindowDimensions();

    window.addEventListener('resize', updateWindowDimensions);

    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, []);

  const platform = getPlatform();
  const storesData = storesDisplayVKDating[platform];

  return (
    <AppContext.Provider value={{ isLoading, storesData, deviceType, stage: 'disabled' }}>
      {children}
    </AppContext.Provider>
  );
}
